import { apiJson } from '@/lib/http';

interface ApiResponse<T> {
  success?: boolean;
  message?: string;
  data: T;
}

export interface ProjectDto {
  id: string;
  teamId: string;
  name: string;
  createdAt: string;
  subscription: number;
  addOn: number;
  status: string;
}

const unwrap = <T>(res: ApiResponse<T> | T): T => (res as ApiResponse<T>)?.data ?? (res as T);

export const projectService = {
  async list(): Promise<ProjectDto[]> {
    return apiJson<ApiResponse<ProjectDto[]> | ProjectDto[]>(`/Projects`).then(unwrap);
  },
  async create(name: string): Promise<ProjectDto> {
    return apiJson<ApiResponse<ProjectDto> | ProjectDto>(`/Projects`, {
      method: 'POST',
      body: JSON.stringify({ name }),
    }).then(unwrap);
  },
  async update(projectId: string, name: string): Promise<ProjectDto> {
    return apiJson<ApiResponse<ProjectDto> | ProjectDto>(`/Projects/${projectId}`, {
      method: 'PUT',
      body: JSON.stringify({ name }),
    }).then(unwrap);
  },
  async suspend(projectId: string): Promise<ProjectDto> {
    return apiJson<ApiResponse<ProjectDto> | ProjectDto>(`/Projects/${projectId}/suspend`, {
      method: 'PUT',
    }).then(unwrap);
  },
  async enable(projectId: string): Promise<ProjectDto> {
    return apiJson<ApiResponse<ProjectDto> | ProjectDto>(`/Projects/${projectId}/enable`, {
      method: 'PUT',
    }).then(unwrap);
  },
  async delete(projectId: string): Promise<void> {
    await apiJson<ApiResponse<void> | void>(`/Projects/${projectId}`, { method: 'DELETE' });
  },
  async listAvailableIds(): Promise<string[]> {
    // From MemoryFrontendController projects endpoint
    return apiJson<string[] | { data: string[] }>(`/Projects`).then((res) => {
      if (Array.isArray(res)) return res;
      if (res && typeof res === 'object' && 'data' in res && Array.isArray((res as { data: unknown }).data)) {
        return (res as { data: string[] }).data;
      }
      return [] as string[];
    });
  }
};


